/**
 * Traduce cualquier falla de una peticion a un `ErrorApi` que un componente
 * pueda mostrar. Vive aparte para que todos los hooks que piden datos digan lo
 * mismo cuando la API responde con error o cuando ni siquiera se pudo llegar.
 */
import { ErrorDeApi } from '../servicios/cliente-api';
import type { ErrorApi } from '../tipos/api';

export function aErrorApi(error: unknown): ErrorApi {
  return error instanceof ErrorDeApi
    ? { codigo: error.codigo, mensaje: error.message }
    : { codigo: 'error_interno', mensaje: 'No pudimos conectarnos con el servidor.' };
}
